import React from "react";
import DataNotFound from "../common/DataNotFound";
import DoughnutChart from "./DoughnutChart";
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';


const CustomLeftPieGraph = ({ graphData, title }) => {
  const data = graphData || [];
  const filteredData = data.filter((item) => item.feedback !== 0);
  let finalData = mergeItemsWithUsersZero(filteredData);
  const feedbackValues = finalData.map((item) => item.feedback);
  const userCounts = finalData.map((item) => item.users);

  const pieData = {
    datasets: [
      {
        label: "",
        data: userCounts,
        backgroundColor: [
          "#FF999A",
          "#65B3FF",
          "#C2C2F0",
          "#FFCC99",
          "#99FB9A",
        ],
        borderWidth: 2,
        userCounts: userCounts,
      },
    ],
  };

  function mergeItemsWithUsersZero(input) {
    let groupedData = {};
    input.forEach((item) => {
      let key = item.users;
      if (!groupedData[key]) {
        groupedData[key] = { feedback: `${item.feedback}`, users: item.users };
      } else {
        groupedData[key].feedback += `,${item.feedback}`;
      }
    });
    return Object.values(groupedData);
  }

  const options = {
    responsive: true,
    cutout: '70%',
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      title: {
        display: false,
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        caretSize: 8,
        backgroundColor: '#1E242C',
        padding: {
          x: 15,
          y: 10,
        },
        callbacks: {
          label: function (tooltipItem) {
            const dataset = tooltipItem.dataset;
            const dataIndex = tooltipItem.dataIndex;
            const feedback = dataset.data[dataIndex];
            const userCount = dataset.userCounts ? dataset.userCounts[dataIndex] : 0;
            return true ? `${userCount}` : `${feedback}`;
          },
        },
      },
      datalabels: {
        display: true,
        anchor: 'end',
        align: 'end',
        offset: 0,
        font: {
          size: 14,
        },
        color: '#000',
        formatter: (value, context) => {
          const index = context.dataIndex;
          return feedbackValues[index];
        },
      },
    },
    layout: {
      padding: {
        left: 20,
        right: 20,
      },
    },
  };

  function renderGraph() {
    if (finalData?.every((item) => item?.users === 0)) {
      return <DataNotFound />;
    }
    return (
      <Doughnut data={pieData} options={options} plugins={[ChartDataLabels]} />
    );
  }

  return (
    <div className="flex flex-col items-center gap-[12px]">
      <p className="h-[50px] font-helveticaText-Medium text-center">{title}</p>
      <div className="max-h-[250px] aspect-[1/1] ">
        {renderGraph()}
      </div>
    </div>
  );
};
export default CustomLeftPieGraph;
